import type { CityConfig } from "../city-template/types";

export const johnstonConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Johnston",
  state: "Rhode Island",
  stateAbbr: "RI",
  slug: "johnston",
  route: "/cities/johnston",
  title: "Emergency Passport Johnston, RI — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Johnston, RI — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Johnston, Graniteville, Simmonsville, and all Providence County.",
  h1: "Emergency & Expedited Passport Services in Johnston, RI",
  heroSubtitle: "Commercial corridor passport expired and you're flying to Rome next week? Graniteville family booking a Caribbean cruise? Thornton resident heading to Canada for business? We help Johnston residents — from the Route 6 business community to the tight-knit Italian-American neighborhoods to the Providence County crossroads families — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Rolling%20green%20hills%20and%20suburban%20landscape%20of%20Johnston%20Rhode%20Island%20with%20the%20commercial%20corridor%20along%20Route%206%20in%20the%20distance%2C%20warm%20late%20afternoon%20sunlight%20casting%20long%20shadows%20across%20peaceful%20residential%20neighborhoods%2C%20classic%20New%20England%20suburban%20community%20with%20mature%20trees%20and%20stone%20walls%2C%20elevated%20landscape%20photography%20with%20natural%20amber%20tones%20and%20rich%20greens%2C%20no%20readable%20text%20or%20signs&width=1800&height=700&seq=johnston-hero-2026&orientation=landscape",
  heroImageAlt: "Johnston Rhode Island rolling suburban landscape with commercial corridor at golden hour",
  geoPosition: "41.8301;-71.4918",
  geoPlacename: "Johnston, Rhode Island",
  lastModified: "2026-06-12",
  regionalAgency: {
    name: "Boston Passport Agency",
    address: "10 Causeway St, Boston, MA 02222",
    distance: "Located in downtown Boston — approximately 48 miles from Johnston, appointments required, typically booked 2+ weeks out",
  },
  nearbyCitiesZips: [
    { name: "Johnston", zips: "02919" },
    { name: "Providence", zips: "02901–02912, 02918, 02940" },
    { name: "Cranston", zips: "02905, 02906, 02907, 02910, 02920, 02921" },
    { name: "Warwick", zips: "02886, 02887, 02888, 02889, 02818" },
    { name: "Pawtucket", zips: "02860, 02861, 02862" },
    { name: "North Providence", zips: "02904, 02911" },
    { name: "East Providence", zips: "02914, 02915, 02916" },
    { name: "West Warwick", zips: "02893" },
    { name: "Coventry", zips: "02816, 02827" },
    { name: "Smithfield", zips: "02917" },
    { name: "Woonsocket", zips: "02895" },
    { name: "Cumberland", zips: "02864, 02827" },
    { name: "Lincoln", zips: "02865" },
    { name: "Scituate", zips: "02857, 02815" },
    { name: "Glocester", zips: "02814, 02859" },
    { name: "Foster", zips: "02825" },
    { name: "Burrillville", zips: "02830, 02858" },
  ],
  benefits: [
    { icon: "ri-flashlight-line", title: "24-Hour Johnston Emergency Processing", desc: "Reserved courier access to the Boston Passport Agency — as fast as 24 hours for Johnston travelers with immediate departures." },
    { icon: "ri-building-2-line", title: "Providence County Crossroads", desc: "Johnston sits at the geographic center of Providence County — bordered by Providence, Cranston, Scituate, Smithfield, and North Providence. We serve this central hub with efficiency." },
    { icon: "ri-globe-line", title: "Italian Heritage & Family Expedited", desc: "Johnston's strong Italian-American community means regular multi-generational Italy travel. We coordinate family passport applications with care and speed." },
    { icon: "ri-map-pin-line", title: "Serving All Johnston Neighborhoods", desc: "Graniteville, Simmonsville, Thornton, Belknap, Hughesdale, Morgan Mills — we cover every Johnston neighborhood and beyond." },
  ],
  internalLinks: [
    { name: "Fast passport services in Providence, RI", route: "/cities/providence" },
    { name: "Expedited passport in Cranston, RI", route: "/cities/cranston" },
    { name: "Quick passport services in North Providence, RI", route: "/cities/north-providence" },
    { name: "Urgent passport services in Warwick, RI", route: "/cities/warwick" },
    { name: "Rhode Island passport services overview", route: "/states/rhode-island" },
  ],
  fpcOfficeAddress: "One Boston Place, Suite 2600, Boston, MA 02108",
  fpcOfficeNote: "Fast Passport Center serves Johnston via secure registered courier with direct access to the Boston Passport Agency at 10 Causeway St. Our registered couriers hand-deliver your documents — meaning you get faster results without the appointment wait. Johnston residents can ship from any UPS Store, FedEx Office, or post office location across the town.",
  fpcOfficeDistance: "Serving Johnston, Cranston, Providence, North Providence, Smithfield, Scituate, and all Providence County communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Johnston and the greater Providence County region. From the Route 6 commercial corridor to the historic village of Graniteville, from Simmonsville's residential neighborhoods to the Thornton hills — we serve every Johnston neighborhood. Our courier service eliminates the need to drive to Boston and wait for a passport agency appointment.",
  nearbyCitiesIntro: "We serve Johnston and all surrounding Providence County communities including Providence, Cranston, North Providence, Smithfield, Scituate, and Warwick. Johnston's central location makes it an ideal hub for passport processing — we also serve travelers departing from T.F. Green Airport and Logan International who need emergency passports.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Johnston as simple as possible — with the efficiency and reliability Providence County families and Route 6 professionals need. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee. Most Johnston travelers start online and ship documents overnight — no office visit required for most services.",
  mistakesIntro: "Johnston travelers encounter unique passport issues — from multi-generational Italy trip coordination to last-minute cruise bookings to name change confusion after marriage. Here are the most common passport mistakes we see from this area.",
  testimonialsIntro: "Johnston travelers — from Graniteville families to Simmonsville commuters to Route 6 business professionals — trust us when their international departure is days away.",
  faqIntro: "Have questions about expedited passports in Johnston, RI? Here are the most common ones we hear from Providence County travelers.",
  statePageRoute: "/states/rhode-island",
  statePageName: "Rhode Island",
  servicesIntro: "Whether you need a renewal before a Logan flight to Rome, an emergency passport for a last-minute cruise, or a first-time passport for a Johnston family vacation — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://dmv.ri.gov",
  dmvLabel: "Rhode Island DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Cannot upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Bereavement or medical crisis", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "Logan flight to Rome in two days? Family wedding in Naples this week? Our emergency courier service submits directly via reserved agency slots — as fast as 24 hours for Johnston-area travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Johnston residents renew fast — no agency visit required for most renewals. Perfect for Providence County families and Route 6 professionals preparing for international travel.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Johnston residents through every step — from Graniteville to Simmonsville to Thornton — with clear instructions for the nearest acceptance location.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms. We guide you through DS-64 and everything needed to avoid costly mistakes — so your Italy heritage trip or Providence County family cruise is not derailed.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions and checklists so your Johnston family trip to Italy or Caribbean cruise stays on schedule.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or a legal name change — we assist with corrected passports so your travel documents match your reservations. Common for Johnston residents after name changes.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for Johnston business travelers and Providence County professionals who travel internationally while their primary passport is in visa processing.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged passport is faster than you think. We guide Johnston-area travelers through the process so your international itinerary stays on track.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. We expedite passport card applications with the same courier service as book passports.",
      bullets: ["Wallet-size convenience", "Land and sea travel to nearby destinations", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Johnston RI", description: "Urgent passport processing for Johnston Rhode Island travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Johnston RI", description: "Fast passport renewal for Johnston Rhode Island residents with a previously-issued passport." },
    { name: "First-Time Passport Johnston RI", description: "New passport application services for Johnston Rhode Island residents applying for their first passport." },
    { name: "Child Passport Johnston RI", description: "Minor passport services for Johnston Rhode Island families with children under 16." },
    { name: "Name Change Passport Johnston RI", description: "Passport name correction after marriage, divorce, or legal name changes for Johnston residents." },
    { name: "Second Passport Johnston RI", description: "Second passport services for Johnston business travelers and frequent international flyers." },
  ],
  testimonials: [
    {
      name: "James P.",
      location: "Johnston, RI",
      rating: 5,
      text: "I needed an emergency passport from Johnston for a last-minute business trip to Toronto. Fast Passport Center had it ready in 4 days. The agent walked me through every form and made sure my photo was right the first time.",
      service: "Emergency Passport",
    },
    {
      name: "The Moretti Family",
      location: "Graniteville, Johnston, RI",
      rating: 5,
      text: "We booked a multi-generational trip to Italy — six passports needed between grandparents, parents, and grandkids. Fast Passport Center coordinated everything in one organized process. All six arrived within 5 days. Absolutely incredible service for Johnston families.",
      service: "Child Passport + Renewals",
    },
    {
      name: "Susan K.",
      location: "Simmonsville, Johnston, RI",
      rating: 5,
      text: "Renewed my passport through Fast Passport Center for a cruise to the Bahamas. Chose the 5-day option and had it back in 3 days. They caught a small photo issue before it became a rejection problem.",
      service: "Passport Renewal",
    },
    {
      name: "Thomas M.",
      location: "Thornton, Johnston, RI",
      rating: 5,
      text: "First-time passport for my son. The agent explained the two-parent rule and helped us get the consent forms right. Processed in 5 days and arrived at our Thornton home right on schedule.",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "john-1",
      name: "Johnston Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1275 Hartford Ave",
      city: "Johnston",
      state: "RI",
      zip: "02919",
      phone: "(401) 231-6340",
      hours: "Mon–Fri 8:00 AM – 4:30 PM, Sat 9:00 AM – 12:00 PM (appointment required)",
      distance: "Central Johnston",
      website: "https://tools.usps.com/find-location.htm?location=1378626",
      websiteLabel: "USPS Location",
      notes: "Main Johnston post office on Hartford Avenue — the commercial heart of town. Passport acceptance services by appointment. Saturday appointments available — a rarity in Rhode Island.",
      icon: "ri-mail-line",
    },
    {
      id: "john-2",
      name: "Cranston Post Office — Park Avenue",
      type: "USPS Passport Acceptance Facility",
      address: "1055 Park Ave",
      city: "Cranston",
      state: "RI",
      zip: "02910",
      phone: "(401) 941-4340",
      hours: "Mon–Fri 8:00 AM – 4:30 PM, Sat 9:00 AM – 12:00 PM (appointment required)",
      distance: "Cranston — ~3 miles from Johnston",
      website: "https://tools.usps.com/find-location.htm?location=1387611",
      websiteLabel: "USPS Location",
      notes: "Nearby alternative for Johnston residents near the Cranston border. Passport acceptance services by appointment. Saturday appointments and photo services available.",
      icon: "ri-mail-line",
    },
    {
      id: "john-3",
      name: "RI DMV — Cranston",
      type: "State DMV / ID Services",
      address: "600 New London Ave",
      city: "Cranston",
      state: "RI",
      zip: "02920",
      phone: "(401) 462-4368",
      hours: "Mon–Fri 8:30 AM – 3:15 PM",
      distance: "Cranston — ~4 miles from Johnston",
      website: "https://dmv.ri.gov",
      websiteLabel: "RI DMV Website",
      notes: "Main Rhode Island DMV office — driver licenses and REAL ID required for passport applications. Appointment strongly recommended.",
      icon: "ri-car-line",
    },
    {
      id: "john-4",
      name: "North Providence Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1900 Mineral Spring Ave",
      city: "North Providence",
      state: "RI",
      zip: "02904",
      phone: "(401) 353-4330",
      hours: "Mon–Fri 8:30 AM – 4:30 PM (appointment required)",
      distance: "North Providence — ~4 miles from Johnston",
      website: "https://tools.usps.com/find-location.htm?location=1378635",
      websiteLabel: "USPS Location",
      notes: "Another nearby option for Johnston residents on the north side of town. Passport acceptance services by appointment.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — typically booked 2+ weeks out, walk-ins not accepted", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive to Boston Passport Agency (48 miles from Johnston)", fpc: "Most Johnston travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — strict eligibility with proof of travel", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public — agency serves emergencies only", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Predictability", agency: "Appointments can be cancelled or unavailable — no guarantee", fpc: "Predictable processing based on selected speed option" },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel only with proof of departure date", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but you handle all shipping and logistics", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "Providence County Guidance", agency: "Generic — no Johnston-specific, Italian heritage, or multi-generational travel expertise", fpc: "Full Johnston/Providence County family and heritage travel knowledge built in" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Multi-Generational Trip Coordination Errors",
      description: "Johnston families frequently book Italy trips with multiple generations — and each generation needs different passport forms, different documentation, and different processing. Mixing up DS-11 vs DS-82 across family members costs weeks. We coordinate the entire family's applications correctly.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Name Change Confusion After Marriage",
      description: "Johnston's strong wedding culture means frequent name changes — and many residents don't realize their passport name must exactly match their airline reservation. Italian carriers are particularly strict about name matching for Italy-bound flights.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Assuming the Boston Agency Takes Walk-Ins",
      description: "The Boston Passport Agency requires appointments even for emergencies. Johnston residents make the 48-mile drive only to be turned away. Our courier channel bypasses this entirely.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Photo Standards at Local Retailers",
      description: "Many CVS, Walgreens, and Walmart locations near Johnston produce photos that fail State Department standards — wrong head proportions, shadows, or off-white backgrounds. We review every photo before submission.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Not Accounting for 6-Month Passport Validity for Schengen Travel",
      description: "Johnston travelers to Italy must have at least 6 months remaining on their passport beyond the return date. This is the most common last-minute discovery — families find out while packing and panic. We can still help on tight timelines.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date and complete your secure order. Takes just a few minutes from your home or office in Johnston." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist, instructions, and document review guidance tailored to your travel situation." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using an overnight shipping option. Most Johnston clients ship from home or the UPS Store on Hartford Avenue — no office visit needed." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through our reserved passport agency availability — so you do not have to drive to Boston or wait at the Boston Passport Agency." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport is completed within the timeframe you selected. No guessing, no hoping an appointment opens up — just certainty for your Providence County travel plans." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Johnston?", a: "We offer Johnston-area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5–10 business days. We review your documents before submission to catch errors that cause delays." },
    { q: "Do I need to visit an office in Johnston?", a: "No. Our service is remote — you complete forms online, visit a local acceptance facility (Johnston Post Office or nearby Cranston/North Providence post offices), then ship documents overnight to our processing center. We handle the State Department submission and return your passport to your Johnston address." },
    { q: "Where can I get passport acceptance in Johnston?", a: "The Johnston Post Office at 1275 Hartford Avenue is your primary acceptance facility — and it offers Saturday appointments, which is rare in Rhode Island. Nearby alternatives include the Cranston Post Office on Park Avenue (~3 miles) and the North Providence Post Office on Mineral Spring Avenue (~4 miles)." },
    { q: "Can you handle multi-generational family passport applications?", a: "Yes — this is one of our most common scenarios for Johnston families. We regularly coordinate 3–6 passport applications for Italy trips spanning grandparents, parents, and grandchildren, ensuring every family member gets the right form and processing speed." },
    { q: "What is the best price for expedited passport service in Johnston?", a: "Government fees are $130 + $60 expedite fee. Our courier fee covers document review, overnight shipping, and State Department submission. Total cost is typically 30–100% lower than FedEx, Staples, and other third-party resellers. We offer a best price guarantee." },
    { q: "What documents do Johnston applicants need?", a: "New passport: certified birth certificate, government-issued photo ID, DS-11 form, and passport photo. Renewal: DS-82 form, current passport, and passport photo. Child passport: DS-11, birth certificate, both parents or notarized consent, and photos. We provide a Johnston-specific checklist." },
    { q: "Can I get a passport photo in Johnston?", a: "Yes — CVS Pharmacy and Walgreens locations on Hartford Avenue and in nearby Cranston and Providence offer passport photos. The Cranston Post Office on Park Avenue also has photo services on-site. Photos must be 2x2 inches, white background, no glasses, neutral expression." },
    { q: "How do I check my Johnston passport status?", a: "Once submitted, we provide tracking at every stage. You can also check the State Department's online passport status system at travel.state.gov. Processing from Johnston to final return shipping typically matches your chosen speed tier." },
    { q: "I'm traveling to Italy — what do I need to know about passport validity?", a: "Italy and all Schengen Area countries require your passport to be valid for at least 6 months beyond your planned return date, and to have at least two blank visa pages. This is the #1 last-minute issue we see from Johnston's Italian-American community. We can expedite renewals even on tight timelines." },
    { q: "Is Johnston near a passport agency?", a: "The nearest passport agency is in Boston — approximately 48 miles from Johnston. However, it only serves travelers with life-or-death emergencies. For standard expedited needs, our courier channel is faster and more accessible than driving to Boston." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Johnston Residents",
    intro: "Johnston's position at the geographic center of Providence County — with its commercial corridor along Route 6, strong Italian-American community, and easy access to both T.F. Green and Logan airports — creates distinct passport timing challenges. Here's what Johnston travelers need to know.",
    cards: [
      {
        icon: "ri-flight-takeoff-line",
        title: "PVD — T.F. Green Airport (Warwick)",
        subtitle: "Just 10 miles from Johnston",
        description: "T.F. Green is a straight shot down I-295 for Johnston residents — one of the most convenient airport commutes in Providence County. The airport serves domestic routes plus limited international connections. Many Johnston families use PVD for connections to JFK, Newark, or Philadelphia for final European destinations.",
        tip: "PVD's proximity to Johnston is a blessing, but don't let it create false confidence. Even for domestic connections to international flights, the airline checks your passport at the first check-in counter — not at the international departure gate.",
      },
      {
        icon: "ri-flight-takeoff-line",
        title: "BOS — Logan International Airport",
        subtitle: "Boston Logan, ~48 miles — the Italy gateway",
        description: "Logan is where Johnston's Italian-American community goes for direct flights to Rome. Alitalia and Delta both offer nonstop Logan-to-Rome service, and these flights are the backbone of Johnston-to-Italy travel. The I-95 drive takes about an hour without traffic — but summer Friday afternoons can stretch that considerably.",
        tip: "Logan's direct Rome flights are heavily booked during summer heritage travel season (June through August). Book flights early, and check your passport validity at the same time — not weeks later when you start packing.",
      },
      {
        icon: "ri-globe-line",
        title: "Italian Heritage & Multi-Generational Travel",
        subtitle: "Johnston has deep Italian-American roots",
        description: "Johnston's Italian-American community is one of the pillars of the town's identity. Multi-generational Italy trips are the single most common travel pattern we see — grandparents, parents, and grandchildren traveling together to visit ancestral hometowns in Campania, Sicily, Calabria, and Abruzzo. These trips require coordinated passport applications for 3–6+ family members, often with a tight summer departure window.",
        tip: "For multi-generational Italy trips, start passport applications at least 8 weeks before departure. Even expedited, coordinating 3–6 applications takes more organization than a single renewal — and we handle all of it in one coordinated process.",
      },
      {
        icon: "ri-building-2-line",
        title: "Route 6 Commercial Corridor & Business Travel",
        subtitle: "Johnston's economic engine drives professional travel",
        description: "The Route 6 corridor through Johnston hosts a concentration of commercial businesses, professional offices, and retail centers. Business travelers from these offices — sales professionals, consultants, and company executives — frequently face short-notice international travel. When a business trip to Toronto, London, or Frankfurt comes up with one week's notice, standard post office processing is not an option.",
        tip: "Route 6 business travelers should check passport validity quarterly. The 6-month rule applies to many European and Asian destinations and can derail even the most carefully planned business trip.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "Johnston & the Italy Connection",
      description: "Johnston's Italian-American heritage runs generations deep — and the desire to visit ancestral hometowns never fades. We have helped Johnston families coordinate passport applications for groups of 8+ family members traveling to Italy together — from the patriarch renewing his passport for the 10th time to the youngest grandchild getting their very first passport. When the family decides it is time to go back to the old country, we make sure every passport is ready.",
    },
  },
  destinations: {
    title: "Where Johnston Travelers Go — And Why Passports Get Urgent",
    intro: "Johnston's Italian-American heritage, central Providence County location, and commercial corridor economy create unique international travel patterns. Here are the most common destinations and the urgency patterns we see.",
    stats: [
      { stat: "40%", label: "of Johnston expedited requests are Italy-related — heritage trips, family reunions, or multi-generational vacations" },
      { stat: "3–6 Weeks", label: "average lead time for multi-generational Italy trips — tight but manageable with expedited processing" },
      { stat: "Jun–Aug", label: "peak season when summer Italy trips, Caribbean cruises, and European family vacations collide" },
      { stat: "48 Hours", label: "shortest turnaround we have accommodated for a Johnston family departing for a wedding in Sicily" },
    ],
    destinations: [
      { name: "Italy", context: "Strong Italian-American community — multi-generational trips to Rome, Naples, Sicily, Calabria, and ancestral hometowns", urgency: "40% of all expedited requests — summer heritage travel peaks June through August", icon: "ri-map-pin-2-line" },
      { name: "Canada", context: "Business travel to Toronto and Montreal, family trips to Quebec, and cross-border commerce from the Route 6 corridor", urgency: "Business trips often booked 1–2 weeks out with fixed meeting dates", icon: "ri-map-pin-2-line" },
      { name: "Caribbean & Bahamas", context: "Cruise departures from Florida ports, all-inclusive resort packages to Dominican Republic and Jamaica", urgency: "Winter cruise deals booked 3–4 weeks out during cold New England months", icon: "ri-map-pin-2-line" },
      { name: "Ireland", context: "Significant Irish heritage alongside Italian roots — family reunions, heritage tours, and Dublin city breaks", urgency: "Heritage trips booked around St. Patrick's season and summer family reunions", icon: "ri-map-pin-2-line" },
      { name: "United Kingdom", context: "Logan direct flights to London, business travel, and connecting flights through Heathrow to Europe", urgency: "Business and academic travel booked 2–3 weeks out", icon: "ri-map-pin-2-line" },
      { name: "Portugal", context: "Rhode Island's growing Portuguese community — family visits to the Azores and mainland Portugal", urgency: "Summer festas and family visits drive June–August demand", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other Rhode Island Service Areas",
    crossLinksDesc: "We serve travelers across the Ocean State with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Providence", route: "/cities/providence" },
      { name: "Cranston", route: "/cities/cranston" },
      { name: "North Providence", route: "/cities/north-providence" },
    ],
  },
  photoLocations: [
    { name: "CVS Pharmacy — Johnston", address: "1395 Atwood Ave, Johnston, RI 02919", hours: "Daily 7 AM – 11 PM", website: "https://www.cvs.com/photo" },
    { name: "Walgreens — Johnston", address: "1493 Atwood Ave, Johnston, RI 02919", hours: "Call for hours", website: "https://www.walgreens.com/photo" },
    { name: "UPS Store — Cranston", address: "1800 Cranston St, Cranston, RI 02920", hours: "Mon–Fri 9 AM – 7 PM, Sat 10 AM – 4 PM", website: "https://www.theupsstore.com/print/passport-photos" },
    { name: "Walmart — Cranston", address: "1776 Plainfield Pike, Cranston, RI 02921", hours: "Daily 7 AM – 10 PM", website: "https://www.walmart.com/cp/photo/1078904" },
    { name: "FedEx Office — Providence", address: "1 Providence Pl, Providence, RI 02903", hours: "Mon–Fri 8 AM – 9 PM, Sat–Sun 10 AM – 6 PM", website: "https://www.office.fedex.com/default/office" },
  ],
  dmvLocations: [
    {
      name: "RI DMV — Cranston",
      address: "600 New London Ave, Cranston, RI 02920",
      hours: "Mon–Fri, 8:30 AM – 3:15 PM",
      note: "Main Rhode Island DMV office — driver licenses, REAL ID, vehicle registration. About 4 miles from Johnston on New London Avenue. Appointment strongly recommended.",
      featured: true,
    },
    {
      name: "AAA Cranston",
      address: "1512 Park Ave, Cranston, RI 02920",
      hours: "Mon–Fri, 9:00 AM – 5:00 PM, Sat 9:00 AM – 1:00 PM",
      note: "AAA members can access limited DMV services including license renewals and REAL ID. Convenient location near the Johnston-Cranston border.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "PVD",
      name: "T.F. Green Airport",
      distance: "About 10 miles from Johnston",
      address: "2000 Post Rd, Warwick, RI 02886",
      note: "Rhode Island's primary airport — an easy drive from Johnston via I-295. One of the most convenient airport commutes in Providence County. Serves domestic destinations and limited international connections.",
      flightUrl: "https://www.pvdairport.com/",
      flightLabel: "T.F. Green Airport Website",
      featured: true,
    },
    {
      code: "BOS",
      name: "Logan International Airport",
      distance: "About 48 miles from Johnston",
      address: "1 Harborside Dr, Boston, MA 02128",
      note: "Major international hub with direct flights to Rome, London, Paris, and worldwide destinations. Johnston's Italian-American community primarily flies from Logan for direct Italy service.",
      flightUrl: "https://www.massport.com/logan-airport",
      flightLabel: "Logan International Website",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from the Rhode Island Department of Health. Online, mail, or in-person options available for Providence County residents including Johnston.",
      url: "https://health.ri.gov/records/",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through the RI Department of Health Vital Records. Required for estate and legal matters in Providence County.",
      url: "https://health.ri.gov/records/",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Johnston Town Clerk. Certified copies available for name changes and legal purposes.",
      url: "https://www.townofjohnstonri.com/town-clerk",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Rhode Island Family Court. Required for name change passport corrections for Providence County residents.",
      url: "https://www.courts.ri.gov/family/",
    },
  ],
};

export default johnstonConfig;